module.exports = __webpack_public_path__ + "img/logo.ee693d92.png";